import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Helper } from '../pages/common/helper';
@Injectable({
  providedIn: 'root'
})
export class HomeService {

  constructor(
    private http: HttpClient
  ) { }

  getContentCategoryList(contentCategoryIDList: any) {
    let param = {
      contentCategoryIDList: contentCategoryIDList
    }
    return this.http.post(Helper.API_URL() + '/api/administration/GetContentCategoryList', param);
  }

  getContentDetailList(contentCategoryIDList: any) {
    let param = {
      categoryTypeIDList: contentCategoryIDList
    }
    return this.http.post(Helper.API_URL() + '/api/administration/GetContentDetailList', param);
  }
  getFeturedContentDetailList() {
    let param = { }
    return this.http.post(Helper.API_URL() + '/api/administration/GetFeaturedContentDetailList', param);
  }
  getContentDetail(contentDetailIDList: any) {
    let param = {
      contentDetailID: contentDetailIDList,
    }
    return this.http.post(Helper.API_URL() + '/api/administration/GetContentDetail', param);
  }
  getContentReminderList(contentCategoryIDList: any) {
    let param = {
      contentCategoryIDList: 'ALL'
    }
    return this.http.post(Helper.API_URL() + '/api/administration/GetContentReminderList', param);
  }

  getContentDocumentList(contentDetailIDList: any) {
    let param = {
      contentDetailIDList: contentDetailIDList,
      docFileNameList:'ALL'
    }
    return this.http.post(Helper.API_URL() + '/api/administration/GetContentDocumentList', param);
  }

  getContentPhotoUrl() {

    return this.http.post(Helper.API_URL() + '/api/administration/GetContentPhotoUrl', {});
  }

  validateContentManagementAccessByShip() {

    return this.http.post(Helper.API_URL() + '/api/administration/ValidateContentManagementAccessByShip', {});
  }
}
